module.exports = __webpack_public_path__ + "img/promo-code.e79b15a7.jpeg";